import React from "react";
import { Plus } from "lucide-react";
import CategoryButton from "./CategoryButton";
import { useTranslation } from "react-i18next";

export interface Category {
  id: number |string;
  name: string;
}

interface Props {
  categories: Category[];
  buttonAddLinkPath: string;
  selectedCategory:string
  showAdd:boolean,
  showAllLable:boolean
}

const CategoriesScroll: React.FC<Props> = ({
  categories,
  buttonAddLinkPath,
  selectedCategory,
  showAdd,
  showAllLable
}) => {
    const {t} = useTranslation();
    return(
  <div className="flex flex-wrap gap-2 py-2">
    {
      showAllLable
      &&
      <CategoryButton
      label={t("all")}
      selected={selectedCategory===""}
      path={""}
    />
    }
    {categories.map((cat) => (
      <CategoryButton
        key={cat.id}
        label={cat.name}
        selected={selectedCategory==cat.id}
        path={`${cat.id}`}
      />
    ))}
    {showAdd && <CategoryButton icon={<Plus size={18} />} path={buttonAddLinkPath} />}
  </div>
  )};

export default CategoriesScroll;
